import { render, staticRenderFns } from "./ModulesIcon.vue?vue&type=template&id=3202eb67&"
import script from "./ModulesIcon.vue?vue&type=script&lang=ts&"
export * from "./ModulesIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports